import React, { Component } from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";

import NavigateNextIcon from "@material-ui/icons/NavigateNext";

class CustomBreadCrumbs extends Component {
  render() {
    const pathNames = this.props.url.split("/").filter((x) => x);
    return (
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumbs"
      >
        {pathNames.map((path, index) => {
          const last = index >= pathNames.length - 1;
          const to = `/${pathNames.slice(0, index + 1).join("/")}`;
          return last ? (
            <Link color="textPrimary" href={to} key={to}>
              {path.charAt(0).toUpperCase() + path.slice(1)}
            </Link>
          ) : (
            <div key={to}>
              {to === "/administration" ? (
                <Link color="textPrimary" href={`/administration`} key={to}>
                  Dashboard
                </Link>
              ) : (
                <div>{path.charAt(0).toUpperCase() + path.slice(1)}</div>
              )}
            </div>
          );
        })}
      </Breadcrumbs>
    );
  }
}

export default CustomBreadCrumbs;
